module.exports = __webpack_public_path__ + "static/media/msi.50c22d1f.svg";